import { observable, action, reaction, when } from 'mobx'
import api from '../api'
import userStore from './userStore'
import commonStore from './commonStore'
import routingStore from './routingStore'
import favoritesStore from './favoritesStore'
import dropdownStore from './dropdownStore'
import guidedIntroductionStore from './guidedIntroductionStore'
import { fromPromise } from 'mobx-utils'
import config from '../utils/config'

import anchorScroll from '../utils/anchorScroll'

class AuthStore {
	@observable inProgress = false
	@observable errors = undefined

	@observable values = {
		username: '',
		email: '',
		password: ''
	}

	constructor() {
		this.logoutIfTokenExpired() // reaction
	}

	@action setUsername(username) {
		this.values.username = username
	}

	@action setEmail(email) {
		this.values.email = email
	}

	@action setPassword(password) {
		this.values.password = password
	}

	@action reset() {
		this.values.username = ''
		this.values.email = ''
		this.values.password = ''
	}

	@action login() {
		this.inProgress = true
		this.errors = undefined
		return api.Auth.login(this.values.email, this.values.password)
			.then(res => {
				if (res) {
					commonStore.setToken(res)
					userStore.fetchUser()
					userStore.fetchMediaCodeType()
					anchorScroll('#favorites', '/', true)
				} else this.errors = 'error loging in'
			})
			.catch(
				action('login errors', err => {
					this.errors = 'error loging in'
				})
			)
			.finally(
				action('login completed', () => {
					this.inProgress = false
				})
			)
	}

	@action loginEasymillions(username, password) {
		// data.isLogin = true;
		this.inProgress = true
		this.errors = undefined
		return api.Auth.loginEasymillions(username, password)
			.then(res => {
				if (res) {
					console.log('got here')
					window.opener.postMessage({ token: res }, window.location.origin)
					commonStore.setToken(res)
				} else this.errors = 'error loging in'
			})
			.catch(
				action('login errors', err => {
					this.errors = 'error loging in with easymillions'
				})
			)
			.finally(
				action('login with ezmillions completed', () => {
					this.inProgress = false
				})
			)
	}

	logout() {
		commonStore.setToken(undefined)
		userStore.forgetUser()
		dropdownStore.closeDropdown()
		favoritesStore.forgetFavorites()
		guidedIntroductionStore.reset()
		return Promise.resolve()
	}

	logoutIfTokenExpired() {
		reaction(
			() => routingStore.location,
			() => this.logoutIfRejected(this.checkAuthentication())
		)
	}

	checkAuthentication() {
		if (!!commonStore.token) {
			return userStore.fetchUser()
		} else {
			return fromPromise.reject(false)
		}
	}

	logoutIfRejected(passedFromPromise) {
		when(
			() => passedFromPromise.state !== 'pending',
			() =>
				passedFromPromise.case({
					rejected: err => this.logout()
				})
		)
	}
}

export default new AuthStore()



// WEBPACK FOOTER //
// ./src/stores/authStore.js